import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'app-basic-details',
  templateUrl: './app-basic-details.component.html'
})
export class AppBasicDetailsComponent {

  /**
   * The formData that is being passed between each sub-component which
   * will eventually be posted to the remote service.
   */
  @Input()
  formData: any;

  /**
   * The Event emitter used to keep track of any changes to the number of
   * creditors that should be in the formData array.
   * @type {EventEmitter<number>}
   */
  @Output()
  updateCreditorCount: EventEmitter<number> = new EventEmitter<number>();

  /**
   * Emits the number of creditors that should actually be in the array.
   */
  public numberOfCreditorsChanged(): void {
    this.updateCreditorCount.emit(this.formData.numberOfCreditors);
  }

  public checkValue(value: string | number): boolean {
    return Number(value) > 0;
  }

}



// WEBPACK FOOTER //
// /home/runner/work/debtpanel-portal/debtpanel-portal/webforms/legal-aid/src/app/basic-details/app-basic-details.component.ts